import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const BASE_KEY = "playbooks";

export const playbooksQueryKeys = {
    all: () => [BASE_KEY] as const,
    detail: (playbookId: number) => [BASE_KEY, playbookId] as const,
} as const satisfies QueryKeyFactory;
